export enum Locale {
    English = "en",
    Spanish = "es"
}
